import { ContattoDTO } from "./contatto-dto";
import { IndirizzoDTO } from "./indirizzo-dto";
import { PersonaGiuridicaDTO } from './persona-giuridica-dto';

export class AutoritaEsproprianteDTO {
	coincideDepositanteLegale: Boolean;
	contatti: ContattoDTO;
	indirizzo: IndirizzoDTO;
	tipoRappresentante: string;
	codiceDelega: string;
	idPersona: string;
	idSedeSelezionata: string;
	personaGiuridica: PersonaGiuridicaDTO;
}